import React from "react";
import { NavLink } from "react-router-dom";
import { SocialIcon } from "react-social-icons";

const Navbar = () => {
    return (
        <header className="bg-primary md: top-0 z-10">
            <div className="container mx-auto flex flex-wrap p-4 flex-col md:flex-row items-center">
                <div className="font-title font-medium mb-4 md:mb-0">
                    <NavLink
                        to="/"
                        exact
                        className="ml-3 text-xl hover:text-white"
                    >
                        Matthew R. Just
                    </NavLink>
                </div>
                <nav className="font-body md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700 flex flex-wrap items-center text-base justify-center">
                    <NavLink
                        to="/courses"
                        activeClassName="text-white"
                        className="mr-5 hover:text-white"
                    >
                        Classes
                    </NavLink>
                    {/* <NavLink
                        to="/projects"
                        activeClassName="text-white"
                        className="mr-5 hover:text-white"
                    >
                        Projects
                    </NavLink> */}
                    <NavLink
                        to="/research"
                        activeClassName="text-white"
                        className="mr-5 hover:text-white"
                    >
                        Research
                    </NavLink>
                </nav>
                {/* <div className="inline-flex py-3 px-3 my-6">
                    <SocialIcon
                        url="https://www.facebook.com/matt.just.14"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://www.linkedin.com/in/matthew-just-7b2bb81ba/"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                    <SocialIcon
                        url="https://github.com/mathjuice"
                        className="mr-4"
                        target="_blank"
                        fgColor="#fff"
                        style={{ height: 35, width: 35 }}
                    />
                </div> */}
            </div>
        </header>
    );
}
export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar.jsx